// extracted by css-extract-rspack-plugin
export default {"semanticTypePicker":"zS9Ii"};